import script from "./RegistrationTextField.vue?vue&type=script&setup=true&lang=js"
export * from "./RegistrationTextField.vue?vue&type=script&setup=true&lang=js"

import "./RegistrationTextField.vue?vue&type=style&index=0&id=5df27e98&scoped=true&lang=css"
import "./RegistrationTextField.vue?vue&type=style&index=1&id=5df27e98&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5df27e98"]])

export default __exports__